import { Injectable } from '@angular/core';
import { Platform } from '@ionic/angular';
import { Storage } from '@ionic/storage';
import { LogService } from '../log.service';

@Injectable({
  providedIn: 'root'
})
export class StoreService {
  constructor(
    private db: Storage,
    private log: LogService,
    private platform: Platform
  ) {}

  /* Hack, platform injection reason:
   * platform.ready needs to be called due a race condiiton
   * https://github.com/ionic-team/ionic-storage/issues/20
   *
   * TODO Check if this is needed on New METS
   */

  async get(key: string) {
    await this.ready();
    return await this.db.get(key).catch(error => {
      this.log.e(
        this,
        `Error retrieving data from key ${key}. Reason: ${JSON.stringify(
          error
        )}`
      );
      throw error;
    });
  }

  async save(key: string, data: any) {
    await this.ready();
    await this.delete(key);
    await this.db.set(key, data).catch(error => {
      this.log.e(
        this,
        `Error saving data from key ${key}. Reason: ${JSON.stringify(error)}`
      );
      throw error;
    });
  }

  async delete(key: string) {
    await this.ready();
    await this.db.remove(key).catch(error => {
      this.log.e(
        this,
        `Error on drop data from key ${key}. Reason: ${JSON.stringify(error)}`
      );
      throw error;
    });
  }

  private async ready() {
    await this.platform.ready();
    await this.db.ready();
  }
}
